
import axios from 'axios';
import { getRequest, postRequest } from '../tools/ajax.js'

const CounselList = params => postRequest('/api/pc/Counsel/CounselList', params);

const AllCounselList = params => postRequest('/api/pc/Counsel/AllCounselList', params);

const ChangeStatus = params => postRequest('/api/pc/Counsel/ChangeStatus', params);

const AddCounse = params => postRequest('/api/pc/Counsel/AddCounse', params);

const CounselDetail = params => postRequest('/api/pc/Counsel/CounselDetail', params);

const GetMembers = params => getRequest('/api/pc/Counsel/GetMembers', params);

const GetIndustrys = params => getRequest('/api/pc/Counsel/GetIndustrys', params);

const GetSecondApprove = params => postRequest('/api/pc/Counsel/GetSecondApprove', params);

const AdviceApprove = params => postRequest('/api/pc/Counsel/AdviceApprove', params);

const SealApply = params => postRequest('/api/pc/Counsel/Sealapply', params);

//不带申请人获取用印二次审批人
const GetSealApprovers = params => postRequest('/api/pc/Counsel/SealApprovers', params);

//带申请人获取用印二次审批人
const GetMemberSeal = params => postRequest('/api/pc/Counsel/MemberSeal', params);

//获取顾问关联的冲突案件
const GetConflictCounsel = params => postRequest('/api/pc/Conflict/GetConflictCounsel', params);
//顾问打印信息
const AdviserDaYin= params => postRequest('/api/pc/Seal/AdviserDaYin', params);

//导出顾问
const ExportCounsel= params => postRequest('/api/pc/Counsel/ExportCounsel', params);

//获取顾问冲突
const IsConflict= params => postRequest('/api/pc/Counsel/IsConflict', params);

//
const GetAllCounsel= params => postRequest('/api/pc/case/GetAllCounsel', params);

// 获取文件
const requestDownLoadFile = params => axios({
    url: '/api/Filer/PcGet',
    responseType:'blob',
    method: 'get',
    params
})
// 获取文件 有日志
const DownLoadFile = params => axios({
    url: '/api/Filer/CaseGet',
    responseType:'blob',
    method: 'get',
    params
})
// 获取文件
const requestDownLoadFilePrint = params => axios({
  url: '/api/Filer/PrintGet',
  responseType:'blob',
  method: 'get',
  params
})

const requestReview = params => axios({
    url: '/api/Filer/PcGet',
    responseType:'arraybuffer',
    method: 'get',
    params
})
export {
    CounselList,ChangeStatus,AddCounse,CounselDetail,requestDownLoadFile,requestReview
    ,GetMembers,GetIndustrys,GetSecondApprove,AdviceApprove,SealApply,GetSealApprovers
    ,GetMemberSeal,GetConflictCounsel,AllCounselList,requestDownLoadFilePrint,AdviserDaYin,DownLoadFile
    ,ExportCounsel,IsConflict,GetAllCounsel,
}